import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const SAVOrderIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="36"
        height="31"
        viewBox="0 0 36 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.7822 3.07308L23.5967 0.238145C23.3675 0.0826671 23.0982 0 22.8229 0H6.08072C5.80539 0 5.53611 0.0826671 5.30688 0.238145L1.12135 3.07308C0.732984 3.33575 0.5 3.77849 0.5 4.2524V26.9319C0.5 27.7148 1.12456 28.3493 1.89518 28.3493H27.0084C27.779 28.3493 28.4036 27.7148 28.4036 26.9319V4.2524C28.4036 3.77849 28.1706 3.33575 27.7822 3.07308ZM17.2421 1.41747H22.8229L25.962 3.54367H17.2421V1.41747ZM13.0566 1.41747H15.847V3.54367H13.0566V1.41747ZM13.0566 4.96113H15.847V12.7572H13.0566V4.96113ZM6.08072 1.41747H11.6614V3.54367H2.94156L6.08072 1.41747ZM27.0084 26.9319H1.89518V4.96113H11.6614V14.1747H17.2421V4.96113H27.0084V26.9319Z"
          fill={themeColor === 'light' ? '#000' : '#fff'}
        />
        <path
          d="M31.7133 13.7867C29.94 12.0133 27.5333 11 25 11C22.4667 11 20.06 12.0133 18.2867 13.7867C16.5133 15.56 15.5 17.9667 15.5 20.5C15.5 23.0333 16.5133 25.44 18.2867 27.2133C20.06 28.9867 22.4667 30 25 30C27.5333 30 29.94 28.9867 31.7133 27.2133C33.4867 25.44 34.5 23.0333 34.5 20.5C34.5 17.9667 33.4867 15.56 31.7133 13.7867Z"
          fill="#FFA800"
        />
        <path
          d="M24.8661 15.4303V14.313C24.8661 14.0322 24.5039 13.8949 24.2959 14.0946L22.4178 15.836C22.2837 15.9608 22.2837 16.1543 22.4178 16.2791L24.2892 18.0205C24.5039 18.214 24.8661 18.0767 24.8661 17.7958V16.6786C27.0863 16.6786 28.8906 18.3576 28.8906 20.4235C28.8906 20.9166 28.79 21.3972 28.5955 21.8279C28.4949 22.0526 28.5687 22.3085 28.7498 22.477C29.0919 22.7953 29.6687 22.683 29.8498 22.2648C30.098 21.6968 30.2321 21.0727 30.2321 20.4235C30.2321 17.6648 27.8308 15.4303 24.8661 15.4303ZM24.8661 24.1685C22.6459 24.1685 20.8415 22.4895 20.8415 20.4235C20.8415 19.9305 20.9421 19.4499 21.1367 19.0192C21.2373 18.7945 21.1635 18.5386 20.9824 18.3701C20.6403 18.0517 20.0634 18.1641 19.8823 18.5823C19.6342 19.1503 19.5 19.7744 19.5 20.4235C19.5 23.1823 21.9013 25.4168 24.8661 25.4168V26.534C24.8661 26.8149 25.2283 26.9522 25.4362 26.7525L27.3076 25.0111C27.4418 24.8863 27.4418 24.6928 27.3076 24.568L25.4362 22.8266C25.2283 22.6331 24.8661 22.7704 24.8661 23.0512V24.1685Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

export default SAVOrderIcon;
